import type {LDFlagSet} from 'launchdarkly-react-client-sdk';

import {camelCaseFlagSet} from 'launchdarkly/LaunchDarklyUtil';
import {MockLaunchDarklyActionType} from 'launchdarkly/MockLaunchDarklyActions';
import {FLAG_DEFAULTS} from 'launchdarkly/RolloutFlagDefaults';
import {BenchlingAction} from 'redux-stores/Action';

export interface MockLaunchDarklyState {
  flags: LDFlagSet;
}

const INITIAL_STATE: MockLaunchDarklyState = {
  flags: camelCaseFlagSet(FLAG_DEFAULTS),
};

export default function reduceLaunchDarkly(
  state: MockLaunchDarklyState = INITIAL_STATE,
  action: BenchlingAction
): MockLaunchDarklyState {
  switch (action.type) {
    case MockLaunchDarklyActionType.SET_FLAGS:
      return {
        ...state,
        flags: action.flags,
      };
    default:
      return state;
  }
}
